<template>
  <a-modal width="50%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onClose" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>Partial Refund</b>
    </a-divider>
    <div class="order-info">
      <a-card :bordered="false" :title="'Product Name       ' +order.orderItemList[0].goodsName "
              :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
              :bodyStyle="{'background-color':'#fbfbfb'}">
      </a-card>
      <a-card :bordered="false"
              :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
              :bodyStyle="{'background-color':'#fbfbfb'}">
        <a-table :bordered="false" :pagination="false" :columns="goodsColumns" rowKey="orderItemId" :data-source="order.orderItemAdminList">
          <div slot="applyAmount" slot-scope="text, record">
            <a-input-number  v-model="record.applyAmount" :step="0.01" :min="0" :max="record.payAmount" style="width: 70%"/>
          </div>
          <template slot="picture" slot-scope="text, record">
            <div><img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/></div>
          </template>
        </a-table>
      </a-card>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary"    @click="handleRefund">
          退款
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {refundAmount} from "@/api/order/refund";


export default {
  name: 'RefundPartForm',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  components: {
    CustomDictTag
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        outTradeNo: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      refundAmount: null,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      goodsColumns: [
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          title: this.$t('规格名称'),
          dataIndex: 'skuName',
          align: 'center'
        },
        {
          title: this.$t('购买数量'),
          dataIndex: 'goodsCount',
          align: 'center'
        },
        {
          title: this.$t('商品实付金额'),
          dataIndex: 'payPrice',
          align: 'center'
        },
        {
          slots: {title: 'applyCountTitle'},
          dataIndex: 'applyCount',
          scopedSlots: {customRender: 'applyCount'},
          align: 'center'
        },
        {
          title: 'Refund amount',
          dataIndex: 'applyAmount',
          scopedSlots: {customRender: 'applyAmount'},
          align: 'center'
        },
      ],

      rules: {}
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        outTradeNo: null,
        remark: null,
      }
      this.refundAmount = null

    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 修改按钮操作 */
    handleDetail(id) {
      this.open = true
      this.formType = 2
    },
    handleRefund(id) {
      let that = this
      let data = {
        orderId: this.order.id,
        orderItemList: this.order.orderItemAdminList
      }
      this.$confirm({
        title: '是否确认退款',
        content: '此操作将生成退款单,并退款',
        onOk() {
          refundAmount(data).then(resp => {
            if (resp.code === "20001") {
              that.$message.success('退款成功', 3);
              that.open = false
              that.$emit('ok')
            }
          });
        },
        onCancel() {
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }

    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 100px;
    }

    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>
